import { useMemo } from 'react';

import { useCacheQuery } from '../../../hooks/use-cache-query';
import {
  GetAppointmentNotesDocument,
  GetAppointmentNotesQueryVariables,
} from '../../types/api/graphql';

export function useAgendaAppointmentNotes(
  variables: GetAppointmentNotesQueryVariables
) {
  const {
    data: agendaAppointmentNotesData,
    loading: agendaAppointmentNotesLoading,
  } = useCacheQuery(GetAppointmentNotesDocument, {
    variables,
    skip: !variables.appointmentId,
  });

  const data = useMemo(
    () =>
      (agendaAppointmentNotesData?.appointmentNotes.map(
        x => x.initials
      ) as string[]) ?? null,
    [agendaAppointmentNotesData?.appointmentNotes]
  );

  return {
    data,
    loading: agendaAppointmentNotesLoading,
  };
}
